// @mui
import {
    Box, Card, CardHeader
} from '@mui/material';
// hooks
import useFeature from '../../../hooks/useFeature';
import { FEATURES } from '../../../constants/features';
// sections
import {
    UpcomingCoursesSection,
    UpcomingSurveysSection,
    UpcomingReviewsSection
} from './upcoming-card';

// ----------------------------------------------------------------------

export default function AdminUpcomingCourses() {
    const { isEnabled: isTrainingEnabled } = useFeature(FEATURES.LEARNING);

    return (
        <Box sx={{ height: '100%' }}>
            {isTrainingEnabled && (
            <Card sx={{ mb: 3 }}>
                <CardHeader title="Training" subheader="" sx={{ textAlign: 'center' }} />
                <UpcomingCoursesSection />
            </Card>
            )}
            <Card sx={{ mb: 3 }}>
                <CardHeader title="Surveys" subheader="" sx={{ textAlign: 'center' }} />
                <UpcomingSurveysSection />
            </Card>
            <Card>
                <CardHeader title="Reviews" subheader="" sx={{ textAlign: 'center' }} />
                <UpcomingReviewsSection />
            </Card>
        </Box>
    )
}
